import { useState } from "react";
import {
  getWebGraphData,
  getNetworkGraphData,
  getGCloudGraphData,
  getAWSCloudGraphData,
  getAzureCloudGraphData,
  getCrowdstrikeGraphData,
  getWiresharkGraphData,
  getSnortGraphData,
  getTenableGraphData,
  getSkyboxGraphData,
  getBalbixGraphData,
  getQualysGraphData,
  getRapidGraphData,
  getEGOGraphData,
  getTripwireGraphData,
  getIntruderGraphData,
  getSaveConnectGraphData,
} from "../../api/get/get-analytics";
import { useAuth } from "../../context/contextAuth";

const useAnalyticsData = () => {
  const { userId, user } = useAuth();
  const [analytics, setAnalytics] = useState([]);
  const [tabData, setTabData] = useState([]);
  const [upgradePlan, setUpgradePlan] = useState(0);
  const [viewHeight, setViewHeight] = useState("85vh");
  const [graphHeight, setGraphHeight] = useState("300px");
  const [graphWidth, setGraphWidth] = useState("100%");
  const [cardLoading, setCardLoading] = useState(false);
  const [graphLoading, setGraphLoading] = useState(false);

  // Tab and duration
  const [selectedTab, setSelectedTab] = useState("WebAnalytics");
  const [selectedDuration, setSelectedDuration] = useState("Last 28 days");

  // Per-tab analytics data
  const [webData, setWebData] = useState(null);
  const [networkData, setNetworkData] = useState(null);
  const [gCloudData, setGCloudData] = useState(null);
  const [awsCloudData, setAWSCloudData] = useState(null);
  const [azureCloudData, setAzureCloudData] = useState(null);
  const [crowdstrikeData, setCrowdstrikeData] = useState(null);
  const [wiresharkData, setWiresharkData] = useState(null);
  const [snortData, setSnortData] = useState(null);
  const [tenableData, setTenableData] = useState(null);
  const [skyboxData, setSkyboxData] = useState(null);
  const [balbixData, setBalbixData] = useState(null);
  const [qualysData, setQualysData] = useState(null);
  const [rapidData, setRapidData] = useState(null);
  const [egoData, setEGOData] = useState(null);
  const [tripwireData, setTripwireData] = useState(null);
  const [intruderData, setIntruderData] = useState(null);
  const [error, setError] = useState(null);

  const initData = async () => {
    if (!user) {
      resetState();
      return;
    }

    await fetchAssets(userId);
  };

  const fetchAssets = async (userId) => {
    try {
      const webData = await getWebGraphData(userId);
      const networkData = await getNetworkGraphData(userId);
      const gCloudData = await getGCloudGraphData(userId);
      const awsCloudData = await getAWSCloudGraphData(userId);
      const azureCloudData = await getAzureCloudGraphData(userId);
      const crowdstrikeData = await getCrowdstrikeGraphData(userId);
      const wiresharkData = await getWiresharkGraphData(userId);
      const snortData = await getSnortGraphData(userId);
      const tenableData = await getTenableGraphData(userId);
      const skyboxData = await getSkyboxGraphData(userId);
      const balbixData = await getBalbixGraphData(userId);
      const qualysData = await getQualysGraphData(userId);
      const rapidData = await getRapidGraphData(userId);
      const egoData = await getEGOGraphData(userId);
      const tripwireData = await getTripwireGraphData(userId);
      const intruderData = await getIntruderGraphData(userId);

      setWebData(webData || null);
      setNetworkData(networkData || null);
      setGCloudData(gCloudData || null);
      setAWSCloudData(awsCloudData || null);
      setAzureCloudData(azureCloudData || null);
      setCrowdstrikeData(crowdstrikeData || null);
      setWiresharkData(wiresharkData || null);
      setSnortData(snortData || null);
      setTenableData(tenableData || null);
      setSkyboxData(skyboxData || null);
      setBalbixData(balbixData || null);
      setQualysData(qualysData || null);
      setRapidData(rapidData || null);
      setEGOData(egoData || null);
      setTripwireData(tripwireData || null);
      setIntruderData(intruderData || null);
    } catch (error) {
      console.error("Error fetching URL assets:", error);
    }
  };

  const resetState = () => {
    setAnalytics([]);
    setTabData([]);
    setUpgradePlan(0);
    setViewHeight("85vh");
    setGraphHeight("300px");
    setGraphWidth("100%");
    setCardLoading(false);
    setGraphLoading(false);
    setSelectedTab("WebAnalytics");
    setSelectedDuration("Last 28 days");
    setWebData(null);
    setNetworkData(null);
    setGCloudData(null);
    setAWSCloudData(null);
    setAzureCloudData(null);
    setCrowdstrikeData(null);
    setWiresharkData(null);
    setSnortData(null);
    setTenableData(null);
    setSkyboxData(null);
    setBalbixData(null);
    setQualysData(null);
    setRapidData(null);
    setEGOData(null);
    setTripwireData(null);
    setIntruderData(null);
    setError(null);
  };

  return {
    initData,
    resetState,

    analytics,
    setAnalytics,
    tabData,
    setTabData,
    upgradePlan,
    setUpgradePlan,
    viewHeight,
    setViewHeight,
    graphHeight,
    setGraphHeight,
    graphWidth,
    setGraphWidth,
    cardLoading,
    setCardLoading,
    graphLoading,
    setGraphLoading,
    selectedTab,
    setSelectedTab,
    selectedDuration,
    setSelectedDuration,

    webData,
    setWebData,
    networkData,
    setNetworkData,
    gCloudData,
    setGCloudData,
    awsCloudData,
    setAWSCloudData,
    azureCloudData,
    setAzureCloudData,
    crowdstrikeData,
    setCrowdstrikeData,
    wiresharkData,
    setWiresharkData,
    snortData,
    setSnortData,
    tenableData,
    setTenableData,
    skyboxData,
    setSkyboxData,
    balbixData,
    setBalbixData,
    qualysData,
    setQualysData,
    rapidData,
    setRapidData,
    egoData,
    setEGOData,
    tripwireData,
    setTripwireData,
    intruderData,
    setIntruderData,
    error,
    setError,
    resetState,
  };
};

export default useAnalyticsData;
